import { cx } from '@linaria/core';
import { TransitionGroup } from 'react-transition-group';
import { CSSRefTransition } from '@utils/react';
import { wrapper, transitionDurationMs } from './notification-count.style.js';
import { jsx } from 'react/jsx-runtime';

function NotificationCount(props) {
  return /*#__PURE__*/jsx(TransitionGroup, {
    component: null,
    children: props.active && /*#__PURE__*/jsx(CSSRefTransition, {
      timeout: transitionDurationMs,
      classNames: wrapper,
      children: ref => /*#__PURE__*/jsx("span", {
        ref: ref,
        className: cx(wrapper, props.className),
        children: props.count
      })
    })
  });
}

export { NotificationCount };
//# sourceMappingURL=notification-count.js.map
